import React, { useEffect, useState } from 'react';
import {
    AppShell,
    Burger,
    Header,
    MediaQuery,
    Navbar,
    ScrollArea,
    Grid,
    Text,
    useMantineTheme,
    Col,
    TextInput,
    Button,
    Modal,
    Card,
    Alert,
    Container,
    Select,
    ActionIcon,
} from "@mantine/core";
import { FaThLarge, FaUserAlt, FaBoxes, FaBriefcase, FaUsers, FaCarAlt, FaElementor, FaCog } from 'react-icons/fa';
import User from '../components/User';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { createNewCustomer, searchCustomer } from '../actions/customerActions';
import { getVehicle, createNewVehicle } from '../actions/vehicleActions';
import { getJobTypes, startNewJob } from '../actions/jobActions';
import { CUSTOMER_SEARCH_RESET } from '../constants/customerConstants';
import { useNotifications } from '@mantine/notifications';
import { DatePicker } from '@mantine/dates';
import { useForm } from '@mantine/hooks';

const Layout = ({ children, activeKey }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const notifications = useNotifications();
    const { userInfo } = useSelector((state) => state.userAccess);
    const [opened, setOpened] = useState(false);
    const [searchModal, setSearchModal] = useState(false);
    const [addCustomerModalOpened, setAddCustomerModalOpened] = useState(false);
    const [addVehicleModalOpened, setAddVehicleModalOpened] = useState(false);
    const [foundCustomer, setFoundCustomer] = useState(2);
    const [startJobModalOpened, setStartJobModalOpened] = useState(false);
    const theme = useMantineTheme();

    const { loading, error: customerSearchError, customerSearch } = useSelector((state) => state.customerSearch);
    const { vehicle } = useSelector((state) => state.vehicle);
    const { loading: startJobLoading, error: startJobError, startJob } = useSelector((state) => state.startJob);
    const { jobTypes } = useSelector((state) => state.getJobTypes);
    const { loading: createCustomerLoading, error: createCustomerError, createCustomer } = useSelector((state) => state.createCustomer);
    const { loading: createVehicleLoading, error: createVehicleError, createVehicle } = useSelector((state) => state.createVehicle);

    const searchForm = useForm({
        initialValues: {
            firstname: '',
            lastname: '',
            nic: '',
            contact: '',
        },
        errorMessages: {
            firstname: 'Enter a valid firstname',
            lastname: 'Enter a valid lastname',
            nic: 'Enter a valid NIC',
            contact: 'Enter a valid contact'
        },
        validationRules: {
            firstname: (value) => value.trim().length >= 2,
            lastname: (value) => value.trim().length >= 2,
            nic: (value) => value.trim().length <= 12,
            contact: (value) => value.trim().length === 10
        },
    });

    let startJobForm = useForm({
        initialValues: {
            districtCode: '',
            vehicleLetters: '',
            vehicleNumber: '',
            lastMileage: '',
            jobType: ''
        },
        errorMessages: {
            lastMileage: 'Please enter a valid mileage',
        },
        validationRules: {
            lastMileage: (value) => value > 0,
        },
    });

    let createVehicleForm = useForm({
        initialValues: {
            customer: '',
            districtCode: '',
            vehicleLetters: '',
            vehicleNumber: '',
            chassisNo: '',
            make: '',
            model: '',
            mileage: '',
            yom: ''
        },
        errorMessages: {
            districtCode: 'Please enter a valid district code',
            vehicleLetters: 'Please enter a valid letters',
            vehicleNumber: 'Please enter a valid numbers',
            make: 'Please enter a valid mileage',
            model: 'Please enter a valid model',
            mileage: 'Please enter a valid mileage',
            yom: 'Please enter a valid YOM'
        },
        validationRules: {
            districtCode: (value) => value.trim().length === 2,
            vehicleLetters: (value) => value.trim().length >= 3,
            vehicleNumber: (value) => value.trim().length === 4,
            make: (value) => value.trim().length > 2,
            model: (value) => value.trim().length > 2,
            mileage: (value) => value.trim().length > 0,
        },
    });

    let createCustomerForm = useForm({
        initialValues: {
            firstname: '',
            lastname: '',
            contact: '',
            email: '',
            dob: '',
            houseNo: '',
            streetAddress: '',
            streetAddress2: '',
            city: '',
            customerType: '',
            nic: ''
        },
        errorMessages: {
            firstname: 'Enter a valid first name',
            lastname: 'Enter a valid last name',
            contact: 'Enter a valid contact',
            email: 'Enter a valid email',
            dob: 'Enter a valid date of birth',
            houseNo: 'Enter a valid house number',
            streetAddress: 'Enter a valid firstname',
            city: 'Enter a valid city',
            customerType: 'Enter a valid customer type',
            nic: 'Enter a valid nic'
        },
        validationRules: {
            firstname: (value) => value.trim().length >= 2,
            lastname: (value) => value.trim().length >= 2,
            contact: (value) => value.trim().length === 10,
            dob: (value) => value.trim().length >= 2,
            email: (value) => /^\S+@\S+$/.test(value),
            houseNo: (value) => value.trim().length >= 1,
            streetAddress: (value) => value.trim().length >= 2,
            city: (value) => value.trim().length >= 2,
            nic: (value) => value.trim().length <= 12,
        },
    })


    const openAddCustomerModalAndSetDetails = () => {
        setAddCustomerModalOpened(true);
        createCustomerForm.setValues({ firstname: searchForm.values.firstname, lastname: searchForm.values.lastname, nic: searchForm.values.nic, contact: searchForm.values.contact })
    }

    const openAddNewVehicleModalAndSelectCustomer = (customerId) => {
        createVehicleForm.setValues({ customer: customerId.uuid })
        setAddVehicleModalOpened(true)
    }

    const clearCustomerSearchResultsOnClose = () => {
        searchForm.reset()
        setSearchModal(false);
        dispatch({
            type: CUSTOMER_SEARCH_RESET,
        });
    }


    const getFormattedJobTypes = (jobTypes) => {
        let formattedJobTypes = [];
        if (jobTypes) {
            jobTypes.map((jobType, id) => (
                formattedJobTypes.push({ key: id, value: jobType.name, label: jobType.name })
            ))
            return formattedJobTypes
        }
    }

    const handlerCreateCustomer = (values) => {
        const { firstname, lastname, contact, email, dob, houseNo, streetAddress, streetAddress2, city, customerType, nic } = values;
        dispatch(createNewCustomer(firstname, lastname, contact, email, dob, houseNo, streetAddress, streetAddress2, city, customerType, nic))
    }

    const handlerCustomerSearch = (values) => {
        const { firstname, lastname, nic, contact } = values;
        dispatch(searchCustomer(firstname, lastname, nic, contact));
    }

    const handlerCreateVehicle = (values) => {
        const { customer, chassisNo, districtCode, make, mileage, model, vehicleLetters, vehicleNumber, yom } = values;
        dispatch(createNewVehicle(customer, districtCode, vehicleLetters, vehicleNumber, chassisNo, make, model, yom, mileage))
    }

    const hanlderStartJob = (values) => {
        const { lastMileage, jobType } = values;
        dispatch(startNewJob(vehicle.vehicle.uuid, jobType, lastMileage))
    }

    const selectVehicleAndGetVehicle = (vehicleNo) => {
        dispatch(getVehicle(vehicleNo));
        setStartJobModalOpened(true)
    }

    useEffect(() => {
        if (vehicle && Object.keys(vehicle).includes('vehicle')) {
            const { vehicle: vehicleInfo } = vehicle;
            startJobForm.setValues({ districtCode: vehicleInfo.vehicleNo.split("-")[0], vehicleLetters: vehicleInfo.vehicleNo.split("-")[1], vehicleNumber: vehicleInfo.vehicleNo.split("-")[2], lastMileage: vehicleInfo.lastMileage })
        }
        // eslint-disable-next-line
    }, [vehicle])

    useEffect(() => {

        if (customerSearch && Object.keys(customerSearch).length === 1) {
            setFoundCustomer(0)
        } else if (customerSearch && Object.keys(customerSearch).length > 1) {
            setFoundCustomer(1)
        } else if (customerSearch && Object.keys(customerSearch).length === 0) {
            setFoundCustomer(2)
        }

    }, [customerSearch])

    useEffect(() => {
        if (customerSearchError) {
            notifications.showNotification({
                title: 'Error',
                message: customerSearchError,
                color: 'red'
            })
        }

        if (createCustomerError) {
            notifications.showNotification({
                title: 'Error',
                message: createCustomerError,
                color: 'red'
            })
        }

        if (createVehicleError) {
            notifications.showNotification({
                title: 'Error',
                message: createVehicleError,
                color: 'red'
            })
        }
        // eslint-disable-next-line
    }, [customerSearchError, createCustomerError, createVehicleError])


    useEffect(() => {
        if (createCustomer) {
            notifications.showNotification({
                title: 'Success',
                message: 'Customer added',
                color: 'green'
            })

            setAddCustomerModalOpened(false)
            createCustomerForm.reset();

        }
        // eslint-disable-next-line
    }, [createCustomer])

    useEffect(() => {
        if (createVehicle) {
            notifications.showNotification({
                title: 'Success',
                message: 'Vehicle added',
                color: 'green'
            })

            setAddVehicleModalOpened(false)
            createVehicleForm.reset();
            const { firstname, lastname, nic, contact } = searchForm.values;
            dispatch(searchCustomer(firstname, lastname, nic, contact))
        }
        // eslint-disable-next-line
    }, [createVehicle])

    const renderVehicleList = (vehicles) => {

        return (
            <Grid sx={{ marginTop: '10px' }}>
                {vehicles && vehicles.map((vehicle, index) => {
                    return <Col key={index} span={4}><Card withBorder shadow='xl' radius='md' sx={{ margin: '10px 0' }} key={index}>
                        <Container sx={{ padding: '0px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                            <span>
                                <Text weight={600}>{vehicle.vehicleNo}</Text>
                                <Text size='sm' color='gray' weight={400}>{vehicle.make} {vehicle.model}</Text>
                            </span>
                            <Button color='orange' radius='md' variant='light' onClick={() => selectVehicleAndGetVehicle(vehicle.uuid)}>Select</Button>
                        </Container>
                    </Card></Col>
                })}
            </Grid>
        )
    }

    useEffect(() => {
        if (startJob && Object.keys(startJob)) {
            notifications.showNotification({
                title: 'Success',
                message: 'Started new Job',
                color: 'green'
            })
            setStartJobModalOpened(false);
            setSearchModal(false);
            navigate('/jobs')
        }

        // eslint-disable-next-line
    }, [startJob])

    useEffect(() => {
        if (startJobError) {
            notifications.showNotification({
                title: 'Error',
                message: startJobError,
                color: 'red'
            })
        }
        // eslint-disable-next-line
    }, [startJobError])


    useEffect(() => {
        if (!userInfo) {
            navigate('/login')
        }

        dispatch(getJobTypes())
    }, [dispatch, userInfo, navigate])

    return (
        <AppShell
            navbarOffsetBreakpoint="sm"
            fixed
            styles={(theme) => ({
                main: { backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0] },
            })}
            navbar={
                <Navbar
                    fixed position={{ top: 0, left: 0 }}

                    hiddenBreakpoint="sm"
                    hidden={!opened}
                    padding={10} width={{ base: 300 }}
                >
                    <Navbar.Section mt="xs">
                        <Button radius='md' size='md' fullWidth loaderPosition="right" color="orange" onClick={() => setSearchModal(true)}>
                            Start New Job
                        </Button>
                    </Navbar.Section>
                    <Link className='sidenav-link' to='/'>
                        <Navbar.Section className={`link ${activeKey === 0 && 'active-link'}`} >
                            <span className='link-container'>
                                <FaThLarge color='black' />
                            </span>
                            <Text size='md' sx={{ marginLeft: '12px' }}>Dashboard</Text>
                        </Navbar.Section>
                    </Link>
                    <Link className='sidenav-link' to='/jobs'>
                        <Navbar.Section className={`link ${activeKey === 1 && 'active-link'}`}>
                            <span className='link-container'>
                                <FaElementor color='black' />
                            </span>
                            <Text size='md' sx={{ marginLeft: '12px' }}>Jobs</Text>
                        </Navbar.Section>
                    </Link>
                    <Link className='sidenav-link' to='/employees'>
                        <Navbar.Section className={`link ${activeKey === 2 && 'active-link'}`} >
                            <span className='link-container'>
                                <FaBriefcase color='black' />
                            </span>
                            <Text size='md' sx={{ marginLeft: '12px' }}>Employees</Text>
                        </Navbar.Section>
                    </Link>
                    <Link className='sidenav-link' to='/inventory'>
                        <Navbar.Section className={`link ${activeKey === 3 && 'active-link'}`}>
                            <span className='link-container'>
                                <FaBoxes color='black' />
                            </span>
                            <Text size='md' sx={{ marginLeft: '12px' }}>Inventory</Text>
                        </Navbar.Section>
                    </Link>
                    <Link className='sidenav-link' to='/suppliers'>
                        <Navbar.Section className={`link ${activeKey === 4 && 'active-link'}`}>
                            <span className='link-container'>
                                <FaUserAlt color='black' />
                            </span>
                            <Text size='md' sx={{ marginLeft: '12px' }}>Suppliers</Text>
                        </Navbar.Section>
                    </Link>
                    <Link className='sidenav-link' to='/customers'>
                        <Navbar.Section className={`link ${activeKey === 5 && 'active-link'}`}>
                            <span className='link-container'>
                                <FaUsers color='black' />
                            </span>
                            <Text size='md' sx={{ marginLeft: '12px' }}>Customers</Text>
                        </Navbar.Section>
                    </Link>
                    <Link className='sidenav-link' to='/vehicles'>
                        <Navbar.Section className={`link ${activeKey === 6 && 'active-link'}`}>
                            <span className='link-container'>
                                <FaCarAlt color='black' />
                            </span>
                            <Text size='md' sx={{ marginLeft: '12px' }}>Vehicles</Text>
                        </Navbar.Section>
                    </Link>
                    <Link className='sidenav-link' to='/general'>
                        <Navbar.Section className={`link ${activeKey === 7 && 'active-link'}`}>
                            <span className='link-container'>
                                <FaCog color='black' />
                            </span>
                            <Text size='md' sx={{ marginLeft: '12px' }}>General</Text>
                        </Navbar.Section>
                    </Link>
                    <Navbar.Section
                        grow
                        component={ScrollArea}
                        ml={-10}
                        mr={-10}
                        sx={{ paddingLeft: 10, paddingRight: 10 }}
                    >
                    </Navbar.Section>
                    {userInfo && <Navbar.Section className={`link ${activeKey === 'user' && 'active-link'}`}><User active={activeKey} /></Navbar.Section>}

                </Navbar >
            }
            header={
                < Header height={70} padding="md" >
                    <div
                        style={{ display: "flex", alignItems: "center", justifyContent: 'space-between', height: "100%" }}
                    >
                        <MediaQuery largerThan="sm" styles={{ display: "none" }}>
                            <Burger
                                opened={opened}
                                onClick={() => setOpened((o) => !o)}
                                size="sm"
                                color={theme.colors.gray[6]}
                                mr="xl"
                            />
                        </MediaQuery>

                        <Text>Carmax ERP</Text>
                        <ActionIcon variant="default">d</ActionIcon>
                    </div>
                </Header >
            }

        >

            <Modal
                size='xl'
                opened={searchModal}
                onClose={() => clearCustomerSearchResultsOnClose()}
                centered
                radius='md'
                title='Search for a customer'
                closeOnClickOutside={false}

            >
                <form onSubmit={searchForm.onSubmit((values) => handlerCustomerSearch(values))}>
                    <Grid>
                        <Col span={6}>
                            <TextInput
                                {...searchForm.getInputProps('firstname')}
                                sx={{ marginTop: '20px' }}
                                placeholder="Firstname"
                                label="Customer Firstname"
                                type='text'
                                radius='md'
                                required
                                error={searchForm.errors.firstname}
                            />
                        </Col>
                        <Col span={6}>
                            <TextInput
                                {...searchForm.getInputProps('lastname')}
                                sx={{ marginTop: '20px' }}
                                placeholder="Lastname"
                                type='text'
                                label="Customer Lastname"
                                radius='md'
                                required
                                error={searchForm.errors.lastname}
                            />
                        </Col>
                    </Grid>
                    <Grid>
                        <Col span={6}>
                            <TextInput
                                {...searchForm.getInputProps('contact')}
                                sx={{ marginTop: '20px' }}
                                placeholder="Phone"
                                label="Customer Phone"
                                type='number'
                                radius='md'
                                required
                                error={searchForm.errors.contact}
                            />
                        </Col>
                        <Col span={6}>
                            <TextInput
                                {...searchForm.getInputProps('nic')}
                                sx={{ marginTop: '20px' }}
                                placeholder="NIC"
                                label="Customer NIC"
                                type='text'
                                radius='md'
                                required
                                error={searchForm.errors.nic}
                            />
                        </Col>
                    </Grid>
                    <Button loading={loading} type='submit' radius='md' fullWidth sx={{ marginTop: '30px' }} color="orange">Search</Button>
                </form>
                <Grid sx={{ marginTop: '20px' }}>

                    {foundCustomer === 0 ?

                        <Col span={12}>
                            <Alert title="Customer not Found" color="red">
                                The customer details entered does not match with the customer details within the system. Complete details to add a new customer.
                            </Alert>
                            <Button fullWidth variant='light' color='orange' sx={{ marginTop: '20px' }} onClick={() => openAddCustomerModalAndSetDetails(true)}>Add Customer</Button>
                        </Col>

                        : foundCustomer === 1 ?
                            <Col span={12}>
                                <Alert title="Customer Found" color="green">
                                    The customer details entered matches with a customer. Select a vehicle below or add a new vehicle.
                                </Alert>
                                <Container sx={{ marginTop: '20px', padding: '0', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                                    <Button loading={createVehicleLoading} color='orange' radius='md' onClick={() => openAddNewVehicleModalAndSelectCustomer(customerSearch.customer)}>Add new Vehicle</Button>
                                </Container>
                                {renderVehicleList(customerSearch.vehicles)}

                            </Col>
                            : <></>
                    }

                </Grid>
            </Modal>
            <Modal
                size='xl'
                opened={addVehicleModalOpened}
                onClose={() => setAddVehicleModalOpened(false)}
                centered
                radius='md'
                title='Add a new Vehicle'
                closeOnClickOutside={false}

            >
                <form onSubmit={createVehicleForm.onSubmit((values) => handlerCreateVehicle(values))}>
                    <Grid sx={{ marginTop: '20px' }}>
                        <Col span={4}>
                            <TextInput
                                {...createVehicleForm.getInputProps('districtCode')}
                                placeholder="Code"
                                label="District Code"
                                radius='md'
                                required
                                error={createVehicleForm.errors.districtCode}
                            /></Col>
                        <Col span={4}>
                            <TextInput
                                {...createVehicleForm.getInputProps('vehicleLetters')}
                                placeholder="Letters"
                                label="Vehicle Letters"
                                radius='md'
                                required
                                error={createVehicleForm.errors.vehicleLetters}
                            />
                        </Col>
                        <Col span={4}>
                            <TextInput
                                {...createVehicleForm.getInputProps('vehicleNumber')}
                                placeholder="Numbers"
                                label="Vehicle Number"
                                radius='md'
                                required
                                error={createVehicleForm.errors.vehicleNumber}
                            />
                        </Col>
                    </Grid>
                    <Grid sx={{ marginTop: '20px' }}>
                        <Col span={4}>
                            <TextInput
                                {...createVehicleForm.getInputProps('chassisNo')}
                                placeholder="Chassis"
                                label="Vehicle Chassis"
                                radius='md'
                                error={createVehicleForm.errors.chassisNo}
                            /></Col>
                        <Col span={4}>
                            <TextInput
                                {...createVehicleForm.getInputProps('make')}
                                placeholder="Make"
                                label="Vehicle Make"
                                radius='md'
                                required
                                error={createVehicleForm.errors.make}
                            />
                        </Col>
                        <Col span={4}>
                            <TextInput
                                {...createVehicleForm.getInputProps('model')}
                                placeholder="Model"
                                label="Vehicle Model"
                                radius='md'
                                required
                                error={createVehicleForm.errors.model}
                            />
                        </Col>
                    </Grid>
                    <Grid sx={{ marginTop: '20px' }}>
                        <Col span={6}>
                            <DatePicker

                                color='orange'
                                maxDate={new Date()}
                                {...createVehicleForm.getInputProps('yom')}
                                label='Year of Manufacture'
                                placeholder="Vehicle Year of Manufacture"
                                radius='md'
                                error={createVehicleForm.errors.yom}
                            /></Col>
                        <Col span={6}>
                            <TextInput
                                {...createVehicleForm.getInputProps('mileage')}
                                placeholder="Mileage"
                                label="Vehicle Mileage"
                                radius='md'
                                type='number'
                                required
                                error={createVehicleForm.errors.mileage}
                            />
                        </Col>
                    </Grid>
                    <Button type='submit' radius='md' fullWidth sx={{ marginTop: '30px' }} color="orange">Add Vehicle</Button>
                </form>
            </Modal>
            <Modal closeOnClickOutside={false} onClose={() => setStartJobModalOpened(false)} radius='md' size='lg' centered opened={startJobModalOpened}>
                <Grid sx={{ marginTop: '20px' }}>
                    <Col span={4}>
                        <TextInput
                            {...startJobForm.getInputProps('districtCode')}
                            placeholder="Code"
                            label="District Code"
                            radius='md'
                            disabled
                        /></Col>
                    <Col span={4}>
                        <TextInput
                            {...startJobForm.getInputProps('vehicleLetters')}
                            placeholder="Letters"
                            label="Vehicle Letters"
                            radius='md'
                            disabled
                        />
                    </Col>
                    <Col span={4}>
                        <TextInput
                            {...startJobForm.getInputProps('vehicleNumber')}
                            placeholder="Numbers"
                            label="Vehicle Number"
                            type='number'
                            radius='md'
                            required
                            disabled
                        />
                    </Col>

                </Grid>
                <form onSubmit={startJobForm.onSubmit((values) => hanlderStartJob(values))}>
                    <TextInput
                        {...startJobForm.getInputProps('lastMileage')}
                        sx={{ marginTop: '20px' }}
                        placeholder="Mileage"
                        label="Current Mileage"
                        type='number'
                        radius='md'
                        required
                    />
                    <Select
                        {...startJobForm.getInputProps('jobType')}
                        label="Select Job Type"
                        placeholder="Job Type"
                        searchable
                        sx={{ marginTop: '20px' }}
                        nothingFound="No options"
                        data={getFormattedJobTypes(jobTypes)}
                        radius='md'
                        required
                    />
                    <Button loading={startJobLoading} type='submit' radius='md' fullWidth sx={{ marginTop: '30px' }} color="orange">Start New Job</Button>
                </form>
            </Modal>
            <Modal title='Add customer and vehicle' centered size='xl' radius='md' onClose={() => setAddCustomerModalOpened(false)} opened={addCustomerModalOpened}>
                <form onSubmit={createCustomerForm.onSubmit((values) => handlerCreateCustomer(values))}>
                    <Grid>
                        <Col span={6}>
                            <TextInput
                                {...createCustomerForm.getInputProps('firstname')}
                                sx={{ marginTop: '20px' }}
                                placeholder="Enter firstname"
                                label="Firstname"
                                type='text'
                                radius='md'
                                required
                                error={createCustomerForm.errors.firstname}
                            />
                        </Col>
                        <Col span={6}>
                            <TextInput
                                {...createCustomerForm.getInputProps('lastname')}
                                sx={{ marginTop: '20px' }}
                                placeholder="Enter Lastname"
                                label="Lastname"
                                radius='md'
                                type='text'
                                required
                                error={createCustomerForm.errors.lastname}
                            />
                        </Col>
                    </Grid>
                    <Grid>
                        <Col span={6}>
                            <TextInput
                                {...createCustomerForm.getInputProps('contact')}
                                sx={{ marginTop: '20px' }}
                                placeholder="Enter Contact"
                                label="Contact"
                                radius='md'
                                type='number'
                                required
                                error={createCustomerForm.errors.contact}
                            />
                        </Col>
                        <Col span={6}>
                            <TextInput
                                {...createCustomerForm.getInputProps('email')}
                                sx={{ marginTop: '20px' }}
                                placeholder="Enter email"
                                label="Email"
                                type='text'
                                radius='md'
                                required
                                error={createCustomerForm.errors.email}
                            />
                        </Col>
                    </Grid>
                    <Grid>
                        <Col span={6}>
                            <DatePicker
                                color='orange'
                                maxDate={new Date()}
                                {...createCustomerForm.getInputProps('dob')}
                                sx={{ marginTop: '20px' }}
                                label='Date of Birth'
                                placeholder="Enter date of birth"
                                radius='md'
                                required
                                error={createCustomerForm.errors.dob}
                            />
                        </Col>
                        <Col span={6}>
                            <TextInput
                                {...createCustomerForm.getInputProps('houseNo')}
                                sx={{ marginTop: '20px' }}
                                placeholder="Enter house number"
                                label="House Number"
                                type='text'
                                radius='md'
                                required
                                error={createCustomerForm.errors.houseNo}
                            />
                        </Col>
                    </Grid>
                    <Grid>
                        <Col span={6}>
                            <TextInput
                                {...createCustomerForm.getInputProps('streetAddress')}
                                sx={{ marginTop: '20px' }}
                                placeholder="Enter street address"
                                label="Street Address"
                                radius='md'
                                type='text'
                                required
                                error={createCustomerForm.errors.streetAddress}
                            />
                        </Col>
                        <Col span={6}>
                            <TextInput
                                {...createCustomerForm.getInputProps('streetAddress2')}
                                sx={{ marginTop: '20px' }}
                                placeholder="Street address 2"
                                label="Street Address 2"
                                type='text'
                                radius='md'
                            />
                        </Col>
                    </Grid>
                    <Grid>
                        <Col span={12}>
                            <TextInput
                                {...createCustomerForm.getInputProps('nic')}
                                sx={{ marginTop: '20px' }}
                                placeholder="Enter nic"
                                label="NIC"
                                radius='md'
                                type='text'
                                required
                                error={createCustomerForm.errors.nic}
                            />
                        </Col>
                    </Grid>
                    <Grid>
                        <Col span={6}>
                            <TextInput
                                {...createCustomerForm.getInputProps('city')}
                                sx={{ marginTop: '20px' }}
                                placeholder="Enter city"
                                label="City"
                                type='text'
                                radius='md'
                                required
                                error={createCustomerForm.errors.streetAddress2}
                            />
                        </Col>
                        <Col span={6}>
                            <Select
                                {...createCustomerForm.getInputProps('customerType')}
                                label="Select customer origin"
                                placeholder="Customer Origin"
                                searchable
                                sx={{ marginTop: '20px' }}
                                nothingFound="No options"
                                data={[
                                    { values: 'Website', label: 'Website' },
                                    { values: 'Facebook', label: 'Facebook' },
                                    { values: 'Friend', label: 'Friend' },
                                ]}
                                radius='md'
                                required
                                error={createCustomerForm.errors.customerType}
                            />
                        </Col>
                    </Grid>
                    <Button type='submit' loading={createCustomerLoading} fullWidth sx={{ marginTop: '30px' }} color='orange' radius='md'>Add Customer</Button>
                </form>
            </Modal>
            {children}

        </AppShell >
    )
}


export default Layout
